var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 8.5C15.5225 8.50187 14.1061 9.08965 13.0613 10.1344C12.0165 11.1792 11.4288 12.5956 11.4269 14.0732H14.2602C14.2602 12.5616 15.4899 11.3333 17 11.3333C18.5102 11.3333 19.7399 12.5616 19.7399 14.0732C19.7399 14.9203 19.0585 15.5352 18.0172 16.3767C17.6771 16.6431 17.3503 16.9264 17.0383 17.2253C15.6245 18.6377 15.5834 20.1379 15.5834 20.3051V21.25H18.4167L18.4153 20.3532C18.4167 20.3306 18.462 19.8064 19.04 19.2298C19.2525 19.0173 19.5203 18.8048 19.798 18.581C20.9015 17.6871 22.5718 16.337 22.5718 14.0732C22.5707 12.5957 21.9833 11.179 20.9387 10.1341C19.8941 9.0892 18.4776 8.5015 17 8.5ZM15.5834 22.6667H18.4167V25.5H15.5834V22.6667Z",
    fill: "#E9F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 2.83337C9.18854 2.83337 2.83337 9.18854 2.83337 17C2.83337 24.8115 9.18854 31.1667 17 31.1667C24.8115 31.1667 31.1667 24.8115 31.1667 17C31.1667 9.18854 24.8115 2.83337 17 2.83337ZM17 28.3334C10.7511 28.3334 5.66671 23.249 5.66671 17C5.66671 10.7511 10.7511 5.66671 17 5.66671C23.249 5.66671 28.3334 10.7511 28.3334 17C28.3334 23.249 23.249 28.3334 17 28.3334Z",
    fill: "#E9F4FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.285af9f06046c0bd063b2d4ce68ffd61.svg";
export { ForwardRef as ReactComponent };